import React, { useCallback, useEffect, useState } from 'react';
import { Row, Form, Col } from 'react-bootstrap';

import {
  DateOptions,
  getReportTypes,
  ReportTypesLookup,
  UtilityTypesLookup,
} from '../ReportHelpers';
import ReportMonthRange from '../../../components/reports/ReportMonthRange';
import ReportCheckBoxPicker from '../../../components/reports/ReportCheckboxPicker';
import ReportUnits from '../ReportUnits';
import GHGReportUnitPicker from '../../../components/reports/GHGReportUnitPicker';
import ReportDropdownObject from '../../../components/reports/ReportDropdownObject';
import MONTHSARRAY from '../../../helpers/months';
import dayjs from 'dayjs';

const styles = {
  form: {
    textAlignLast: 'center',
    display: 'block',
  },
  label: {
    display: 'flex',
  },
};

export default function TranscriptReport(props) {
  const { organizationData, updatePayload, activeGHGLicense } = props;

  const [localBaselineYear, setLocalBaselineYear] = useState();

  const [localReportTypes, setLocalReportTypes] = useState([]);

  const [localPayload, setLocalPayload] = useState({});
  const [trendMonths, setTrendMonths] = useState([]);
  const [trendMonth, setTrendMonth] = useState(11);

  const updateLocal = useCallback((key, val) => {
    setLocalPayload((prev) => ({ ...prev, [key]: val }));
  }, []);

  useEffect(() => {
    let temp_baseline = organizationData['default_start_date'];
    temp_baseline = dayjs.utc(temp_baseline)
    temp_baseline = temp_baseline.year(temp_baseline.year() - 1)
    setLocalBaselineYear(temp_baseline);
    updatePayload('baseline_start_year', temp_baseline.year());
    updatePayload('baseline_start_month', temp_baseline.month());
    updatePayload('baseline2_start_year', 'none');
    updatePayload('baseline2_start_month', 'none');
  }, [organizationData, updatePayload]);

  useEffect(() => {
    if (localPayload['start_month']) {
      let local_trend_months = [];
      let start = localPayload['start_month'];
      for (let i = 0; i < 12; i++) {
        local_trend_months.push((i + start - 1) % 12);
      }
      setTrendMonths(local_trend_months);
      setTrendMonth(11);
      updatePayload('trend_month', 11);
    }
  }, [localPayload, updatePayload]);

  return (
    <>
      <Row>
        <Col md={8} style={{ paddingLeft: '0' }}>
          <ReportMonthRange
            major_label={'Trend Date Range'}
            label='Start Month'
            default_date={organizationData['default_start_date']}
            min_date={organizationData['min_date']}
            max_date={organizationData['max_date']}
            payload_key={'start'}
            updatePayload={updatePayload}
            updateLocal={updateLocal}
            showPicker={true}
          />
        </Col>
        <Col md={4} style={{ paddingLeft: '0' }}>
          <Form style={styles.form}>
            <Form.Group controlId={'trendMonth'}>
              <Form.Label style={styles.label}>Trend Month</Form.Label>
              <Form.Control
                as='select'
                onChange={(e) => {
                  updatePayload('trend_month', e.target.value);
                  setTrendMonth(e.target.value);
                }}
                value={trendMonth}
                style={{ height: '32px' }}
              >
                {trendMonths.map((month, idx) => (
                  <option key={`report-opt-${month}`} value={idx}>
                    {MONTHSARRAY[month]}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Col>
      </Row>
      <Row>
        <Col md={6} style={{ paddingLeft: '0' }}>
          <ReportMonthRange
            major_label={'Baseline Date Range'}
            label='Start Month'
            default_date={localBaselineYear}
            min_date={organizationData['min_date']}
            max_date={organizationData['max_date']}
            payload_key={'baseline_start'}
            updatePayload={updatePayload}
            updateLocal={updateLocal}
            showPicker={true}
          />
        </Col>
        <Col md={6} style={{ paddingLeft: '0' }}>
          <ReportMonthRange
            major_label={'Second Baseline Date Range'}
            label='Start Month'
            default_date={null}
            min_date={organizationData['min_date']}
            max_date={organizationData['max_date']}
            payload_key={'baseline2_start'}
            updatePayload={updatePayload}
            updateLocal={updateLocal}
            showPicker={true}
            clearOption={true}
          />
        </Col>

      </Row>
      <Row>
        <Col>
          <ReportCheckBoxPicker
            label={'Utility Types'}
            checkboxOptions={organizationData['utility_types']}
            checkboxLookups={UtilityTypesLookup}
            defaults={organizationData['utility_types']}
            requireds={[]}
            payload_key={'utility_types'}
            updatePayload={updatePayload}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <ReportCheckBoxPicker
            label={'Report Types'}
            checkboxOptions={getReportTypes(activeGHGLicense)}
            checkboxLookups={ReportTypesLookup}
            defaults={getReportTypes(activeGHGLicense)}
            requireds={[]}
            payload_key={'report_types'}
            updatePayload={updatePayload}
            updateLocal={setLocalReportTypes}
          />
        </Col>
      </Row>
      <ReportDropdownObject
        updatePayload={updatePayload}
        payload_key={'date_option'}
        values={DateOptions}
        defaultValue={1}
        label={'Date Option'}
        key_option={'index'}
      />
      <ReportUnits
        organizationData={organizationData}
        updatePayload={updatePayload}
      />
      {localReportTypes.includes('ghg') && (
        <GHGReportUnitPicker
          payload_key={'ghg_unit'}
          updatePayload={updatePayload}
        />
      )}
    </>
  );
}
